import { Dispatch, SetStateAction } from 'react';
import Modal from 'react-modal';



export function PlanoDeAmostragem({planoAmostragensOpen, setPlanoAmostragensOpen} : {planoAmostragensOpen : boolean, setPlanoAmostragensOpen : Dispatch<SetStateAction<boolean>>}) {


    return (
        <Modal className={"justify-self-center justify-center flex w-full h-full p-52 z-[1000]"} isOpen={planoAmostragensOpen}>
        <div className="bg-white opacity-100 flex flex-col w-1/2 rounded-md shadow-lg z-[1200] h-2/3">
            <div className="flex w-full justify-between  bg-rodrimaq-red rounded-t-md p-3">
                <div className="text-white font-bold">Plano de amostragem</div>
                <div className="text-white cursor-pointer hover:underline" onClick={() => setPlanoAmostragensOpen(false)}>Fechar</div>
            </div>
            <div className="p-5 px-12">
                <ul>
                    <li className="flex w-full justify-between">
                        <span className="font-bold">Peças (unidade)</span>
                        <span className="font-bold">Medições (unidade)</span>
                    </li>
                    <hr className="mb-5" />

                    <li className="flex w-full justify-between">
                        <span className="font-bold">1-5</span>
                        <span className="ml-2">Total</span>
                    </li>
                    <hr className="mb-2"/>
                    <li className="flex w-full justify-between">
                        <span className="font-bold">6-50</span>
                        <span className="ml-2"><span className="font-bold">1</span> em cada <span className="font-bold">10</span></span>
                    </li>
                    <hr className="mb-2"/>
                    <li className="flex w-full justify-between">
                        <span className="font-bold">51-100</span>
                        <span className="ml-2"><span className="font-bold">2</span> em cada <span className="font-bold">20</span></span>
                    </li>
                    <hr className="mb-2"/>
                    <li className="flex w-full justify-between">
                        <span className="font-bold">{`>100`}</span>
                        <span className="ml-2"><span className="font-bold">2</span> em cada <span className="font-bold">100</span></span>
                    </li>
                    <hr className="mb-2"/>
                </ul>
            </div>
        </div>
    </Modal>
    )



}